import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["ClientButton"] */ "/app/src/components/Button/Button.client.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Card/wave.png");
;
import(/* webpackMode: "eager", webpackExports: ["LottieOnScroll"] */ "/app/src/components/LottieOnScroll/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/sections/product/components/PillarHero.tsx");
